var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-switch',_vm._b({ref:"switch",attrs:{"active-color":_vm.switchActiveColor,"inactive-color":_vm.switchInactiveColor,"active-icon-class":_vm.switchActiveIcon,"inactive-icon-class":_vm.switchInactiveIcon},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'el-switch',_vm.trimAttrs(_vm.$attrs),false))
}
var staticRenderFns = []

export { render, staticRenderFns }